import { CheckSquare, Square } from 'lucide-react';
import type { RepositoryAnalysis } from '../../types/analysis.types';
import { SelectableRecommendationCard } from '../shared/SelectableRecommendationCard';

interface SelectControlsProps {
  recommendations: RepositoryAnalysis['recommendations'];
  selectedCount: number;
  allSelected: boolean;
  noneSelected: boolean;
  isSelected: (id: string) => boolean;
  toggleSelection: (id: string) => void;
  toggleAll: () => void;
}

export const SelectControls: React.FC<SelectControlsProps> = ({
  recommendations,
  selectedCount,
  allSelected,
  noneSelected,
  isSelected,
  toggleSelection,
  toggleAll,
}) => (
  <>
    <div className="mb-4 flex items-center justify-between">
      <button
        onClick={toggleAll}
        className="btn-secondary inline-flex items-center gap-2"
        aria-label={allSelected ? 'Deselect all recommendations' : 'Select all recommendations'}
      >
        {allSelected ? (
          <CheckSquare className="w-5 h-5 text-teal-500" />
        ) : (
          <Square className="w-5 h-5" />
        )}
        <span>{allSelected ? 'Deselect All' : 'Select All'}</span>
      </button>

      {!noneSelected && (
        <span className="text-sm text-secondary">
          {selectedCount} of {recommendations.length} selected
        </span>
      )}
    </div>

    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
      {recommendations.map((rec) => (
        <SelectableRecommendationCard
          key={rec.id}
          recommendation={rec}
          isSelected={isSelected(rec.id)}
          onToggle={toggleSelection}
        />
      ))}
    </div>
  </>
);
